import * as React from 'react';
import { SVGProps } from 'react';
const SvgPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" stroke="#079664" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 2.929v14.142M2.929 10h14.142" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgPlusIcon;
